module.exports = __webpack_public_path__ + "resource/img/image023Dark.60701ade.png";